import React, { useContext } from 'react'

interface IPageThemeContext {
  pageWidth: '1080' | '1280'
  navigation: '2023' | '2024'
  color: 'asIs' | 'convertTo2024'
}

export const PageThemeContext = React.createContext<IPageThemeContext>({
  pageWidth: '1080',
  navigation: '2023',
  color: 'asIs',
})

export const PageThemeProvider = PageThemeContext.Provider

export const usePageTheme = () => useContext(PageThemeContext)
